const element = document.querySelector('[data-dialog]');

if (element) {
    // Add promise for older browsers so we can run Sentry
    if (!Promise.allSettled) {
        Promise.allSettled = function (promises) {
            return new Promise((resolve) => {
                let results = [];

                let remaining = promises.length;

                if (remaining === 0) {
                    resolve([]);

                    return;
                }

                // Iterate over each promise
                promises.forEach((p, index) => {
                    // Make sure each item is treated as a promise, even if it's a non-promise
                    Promise.resolve(p)
                        .then(
                            (value) => {
                                results[index] = {status: 'fulfilled', value};
                            },
                            (reason) => {
                                results[index] = {status: 'rejected', reason};
                            },
                        )
                        .finally(() => {
                            remaining -= 1;
                            if (remaining === 0) {
                                // Return all results once all promises settle
                                resolve(results);
                            }
                        });
                });
            });
        };
    }

    import('./Libraries/BrowserWarning');
}
